//Styles
import { useEffect } from "react";
import { aboutSystemInformation } from "../../constants/constants";
import Styles from "./Help.module.scss";
import classnames from "classnames";

//Redux
import { closeWindow, openWindow } from "../../actions";
import { useDispatch } from "react-redux";
import { APP_KEY_IDS } from "../../constants/constants";
import { DOCK_MENU } from "../dock/Dock";
import { MOBILE_APPS } from "../mobile/app-panel/AppPanel";


const Help = () => {

    const dispatch = useDispatch()

    return (
        <div className={Styles.container} onClick={() => { dispatch(closeWindow(APP_KEY_IDS.HELP)) }}>
            <div className={classnames(Styles.help_container, "glassBackground")}>
                <div className={Styles.title}>
                    Help
                </div>

                <div className={Styles.app_descriptions_container}>
                    {
                        DOCK_MENU.map((app: any) => {
                            return (
                                <div className={Styles.app_card} key={app.id}>
                                    <div className={Styles.app}>
                                        <div className={Styles.app_icon} id={app.id} ></div>
                                        <div className={Styles.app_label}>
                                            {app.label}
                                        </div>
                                    </div>
                                    <div className={Styles.app_description}>
                                        {app.description}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={Styles.mobile_app_descriptions_container}>
                    {
                        MOBILE_APPS.map((app: any) => {
                           if(app.id && app.label){
                            return (
                                <div className={Styles.app_card} key={app.id}>
                                    <div className={Styles.app}>
                                        <div className={Styles.app_icon} id={app.id} ></div>
                                        <div className={Styles.app_label}>
                                            {app.label}
                                        </div>
                                    </div>
                                    <div className={Styles.app_description}>
                                        {app.description}
                                    </div>
                                </div>
                            )
                           }
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Help
